import { i18n } from "../i18n/i18n";

import React, { Component } from 'react'
import { compact, map } from 'lodash'
import { MetadataData } from '../apis/metadata.api'
import Card from '../components/Card'
import PageHeading from '../components/PageHeading'
import TableVertical, {
  TableVerticalHeader
} from '../components/TableVertical'

interface InventoryMetadataTableProps {
  metadatas: MetadataData[]
}

export default class InventoryMetadataTable
  extends Component<InventoryMetadataTableProps> {
  get headers (): TableVerticalHeader[] {
    const headers = map(this.props.metadatas, (metadata, index) => {
      if (!metadata.meta || !metadata.meta.value) return
      const heading = metadata.meta.value
      const path = `[${index}].value`
      return { heading, path }
    })
    return compact(headers)
  }

  render () {
    return (
      <Card>
        <PageHeading text={i18n("Metadata")} />
        <TableVertical
          headers={this.headers}
          data={this.props.metadatas} />
      </Card>
    )
  }
}
